import {TheRaveSymbol} from "./TheRaveSymbol";
import {TheRaveSymbolState} from "./TheRaveSymbolConfig";
import {TimelineLite} from "gsap";
import {TheRave} from "../TheRave";
import {TheRaveSound} from "../sound/TheRaveSound";

export class TheRaveSplitSymbol extends TheRaveSymbol {

    private _symbolSpine: PIXI.spine.Spine;
    private _symbolSpineBlend: PIXI.spine.Spine;

    constructor(symbolName: string, reelId: number, initState: TheRaveSymbolState, symHeight: number = 150, linkedNum: number = 1) {
        super(symbolName, reelId, initState, symHeight);
    }

    public addSplitSymbolAnimation(newSize: number = 1, useGivenSize: boolean = false): TimelineLite {
        this.updateLayers();
        if (useGivenSize) {
            this.symbolSize = newSize;
        } else {
            this.symbolSize *= 2;
        }
        const tl: TimelineLite = new TimelineLite(),
            part = this._symbolPart;
        this.prepareSpine();
        tl.add(() => {
            if (this._symbolSpine) {
                this._symbolSpine.state.setEmptyAnimation(0, 0);
                this._symbolSpine.visible = false;
                this._symbolSpineBlend.state.setEmptyAnimation(0, 0);
                this._symbolSpineBlend.visible = false;
            }
        });
        tl.add(() => {
            part.part.alpha = 1;
            const text: PIXI.Sprite = new PIXI.Sprite(TheRave.assetLoader.getTextures("wildOnXS/WText")[0]);
            text.name = "wildTextOnXS";
            text.anchor.set(0.5, 0.5);
            part.part.addChild(text);
            text.scale.y = ((this.symbolHeight<150) ? 0.7 : 1);
        });
        return tl;
    }

    public restoreXS(newSize: number = 1, useGivenSize: boolean = false): void {
        this.updateLayers();
        if (useGivenSize) {
            this.symbolSize = newSize;
        } else {
            this.symbolSize *= 2;
        }
        const part = this._symbolPart;
        part.part.alpha = 1;
        const text: PIXI.Sprite = new PIXI.Sprite(TheRave.assetLoader.getTextures("wildOnXS/WText")[0]);
        text.name = "wildTextOnXS";
        text.anchor.set(0.5, 0.5);
        text.scale.y = ((this.symbolHeight<150) ? 0.7 : 1);
        part.part.addChild(text);
    }

    protected updateLayers() {
        if (this._symbolSpine) {
            this.addChild(this._symbolSpine);
            this.addChild(this._symbolSpineBlend);
        }
    }

    public playLanding(init: boolean = false, reelId: number): TimelineLite {
        const tl = new TimelineLite(),
             id: number = TheRave.enhancerReels[reelId - 5].reelView.symId,
            dir: string = (id === 2 ? "upDown" : (id === 1 ? "down" : "up"));
        this.prepareSpine();
        tl.add([
            () => {
                this.updateLayers();
                this._symbolSpine.visible = true;
                this._symbolSpine.state.setAnimation(0, dir, false);
                this._symbolSpineBlend.visible = true;
                this._symbolSpineBlend.state.setAnimation(0, "attention", false);
                TheRaveSound.playSoundEffect("xSplitLanding");
            }], 0);
        tl.add(()=>{
            if(this._symbolSpine) {
                this._symbolSpine.destroy();
            }
            this._symbolSpine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`xSplitNORMAL`));
            this._symbolSpine.name = "xSplitNORMAL";
            this._symbolSpine.autoUpdate = true;
            this._symbolSpine.position.set(0, 0);
            this.addChild(this._symbolSpine);
            this._symbolSpine.state.setAnimation(0, `${dir}Idle`, true);
        }, 0.934);
        return tl;
    }

    private prepareSpine(): void {
        if (!this._symbolSpine) {
            this._symbolSpine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`xSplitNORMAL`));
            this._symbolSpine.name = "xSplitNORMAL";
            this._symbolSpine.autoUpdate = true;
            this._symbolSpine.position.set(0, 0);
            this._symbolSpine.visible = false;
            this._symbolSpineBlend = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`xSplitBLEND`));
            this._symbolSpineBlend.name = "xSplitBLEND";
            this._symbolSpineBlend.autoUpdate = true;
            this._symbolSpineBlend.position.set(0, 0);
            this._symbolSpineBlend.visible = false;
        }
    }
}